import { Button, ButtonGroup, Stack, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { filterTermSelected, showTerms } from 'app/thunks'
import React from 'react'
import { TaxonomyId, TaxonomyState, TermId } from 'types'

type TaxonomyButtonsProps<T extends TaxonomyId> = {
  taxonomy: TaxonomyState<T>
}

const TaxonomyButtons = <T extends TaxonomyId>({
  taxonomy,
}: TaxonomyButtonsProps<T>) => {

  const dispatch = useAppDispatch()

  const { termsLoaded, taxonomyId, selections, termTree, entities: terms } = taxonomy

  React.useEffect(() => {
    if(!termsLoaded) dispatch(showTerms(taxonomyId))
  }, [dispatch, termsLoaded, taxonomyId])

  const handleClick = (termId: TermId) => {
    dispatch(filterTermSelected({ taxonomyId, termId, checked: true, reset: true }))
  }


  return (
    <Stack direction={'row'} alignItems={'center'} flexWrap="wrap">
      <Typography margin={1} ml={0}>Displaying results in:</Typography>
      <ButtonGroup variant="contained" color="inherit" size="large">
        {termTree.map(({ id: termId }, i) => {
          const term = terms[termId]

          if (!term) return null

          const { name } = term
          const checked = selections.includes(termId) ?? false

          return (
            <Button
              key={i}
              size={'large'}
              sx={{paddingY: '15px'}}
              color={checked ? 'primary' : 'inherit'}
              onClick={(e) => handleClick(termId)}
              children={name}
            />
          )
        })}
      </ButtonGroup>
    </Stack>
  )
}

export default TaxonomyButtons
